// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-form-container{
    padding:10px;
    background-color: #007bffd6;
    text-align: center;
    border-radius:10px;
}


.login-form-container{
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: white;
    padding: 20px;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);
    z-index: 5000;
    overflow-y: auto;
    height: 20%;
    width: 60vw;
    border-radius:10px;
}

@media (max-width: 1500px) {
    .login-form-container{
        height: 40vh;
        width: 45vw;
    }
}

/* 
@media (max-width: 1023px) {
    .login-form-container{
        height: 40vh;
        width: 50vw;
    }
} */

@media (max-width: 769px) {
    .login-form-container{
        height: 35vh;
        width: 70vw;
    }
}

@media (max-width: 500px) {
    .login-form-container{
        height: 50vh;
        width: 80vw;
    }
}



.form-action-button{
    width:48%;
    border-radius: 50px !important
}

  




`, "",{"version":3,"sources":["webpack://./src/css/login.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,2BAA2B;IAC3B,kBAAkB;IAClB,kBAAkB;AACtB;;;AAGA;IACI,eAAe;IACf,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,uBAAuB;IACvB,aAAa;IACb,2CAA2C;IAC3C,aAAa;IACb,gBAAgB;IAChB,WAAW;IACX,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI;QACI,YAAY;QACZ,WAAW;IACf;AACJ;;AAEA;;;;;;GAMG;;AAEH;IACI;QACI,YAAY;QACZ,WAAW;IACf;AACJ;;AAEA;IACI;QACI,YAAY;QACZ,WAAW;IACf;AACJ;;;;AAIA;IACI,SAAS;IACT;AACJ","sourcesContent":[".login-form-container{\n    padding:10px;\n    background-color: #007bffd6;\n    text-align: center;\n    border-radius:10px;\n}\n\n\n.login-form-container{\n    position: fixed;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    background-color: white;\n    padding: 20px;\n    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);\n    z-index: 5000;\n    overflow-y: auto;\n    height: 20%;\n    width: 60vw;\n    border-radius:10px;\n}\n\n@media (max-width: 1500px) {\n    .login-form-container{\n        height: 40vh;\n        width: 45vw;\n    }\n}\n\n/* \n@media (max-width: 1023px) {\n    .login-form-container{\n        height: 40vh;\n        width: 50vw;\n    }\n} */\n\n@media (max-width: 769px) {\n    .login-form-container{\n        height: 35vh;\n        width: 70vw;\n    }\n}\n\n@media (max-width: 500px) {\n    .login-form-container{\n        height: 50vh;\n        width: 80vw;\n    }\n}\n\n\n\n.form-action-button{\n    width:48%;\n    border-radius: 50px !important\n}\n\n  \n\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
